import { useState, useCallback } from 'react';
import { message } from 'antd';
import { d312Api, QueryParams, MovementRow, Summary } from '../../../services/d312Api';

export function useD312Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<MovementRow[]>([]);
  const [summary, setSummary] = useState<Summary | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await d312Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setSummary(resp.summary || null);
        setNoData(false);
      } else {
        setData([]);
        setSummary(null);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setSummary(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, summary, queried, noData, runQuery, reset };
}
